var _rect, _rect2, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _g, _rect3, _rect4, _path7, _path8, _path9, _path0, _ellipse2, _path1, _path10, _g2, _rect5, _rect6, _path11, _path12, _path13, _path14, _ellipse3, _path15, _path16, _g3, _rect7, _rect8, _path17, _path18, _path19, _path20, _ellipse4, _path21, _path22, _g4, _rect9, _rect0, _path23, _path24, _path25, _path26, _ellipse5, _path27, _path28, _g5, _rect1, _rect10, _path29, _path30, _path31, _path32, _ellipse6, _path33, _path34, _g6, _path35, _circle, _path36, _circle2, _circle3, _circle4, _circle5, _circle6, _rect11, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveSwimming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 143,
    viewBox: "0 0 269 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.0479,
    y: 60.0937,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 76.0479 60.0937)",
    fill: "#60A3FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0479,
    y: 60.0937,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 76.0479 60.0937)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6771 91.3253L92.3034 90.916C93.3889 90.6428 94.5143 90.5641 95.6273 90.6836L98.9622 91.0414C100.075 91.1609 101.201 91.0822 102.286 90.809L105.539 89.9905C106.624 89.7173 107.75 89.6386 108.863 89.7581L112.198 90.1159C113.311 90.2354 114.436 90.1567 115.522 89.8835L118.774 89.065C119.86 88.7918 120.985 88.7131 122.098 88.8326L123.765 89.0115",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1362 97.1455L94.3001 96.8447C95.4233 96.5544 96.5903 96.4728 97.743 96.604L100.132 96.8758C101.285 97.007 102.452 96.9253 103.575 96.635L105.903 96.0334C107.026 95.7431 108.193 95.6615 109.345 95.7927L111.734 96.0645C112.887 96.1956 114.054 96.114 115.177 95.8237L117.505 95.2221C118.628 94.9318 119.795 94.8502 120.948 94.9813L122.142 95.1172",
    stroke: "white",
    strokeWidth: 2.36925,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1362 97.1455L94.3001 96.8447C95.4233 96.5544 96.5903 96.4728 97.743 96.604L100.132 96.8758C101.285 97.007 102.452 96.9253 103.575 96.635L105.903 96.0334C107.026 95.7431 108.193 95.6615 109.345 95.7927L111.734 96.0645C112.887 96.1956 114.054 96.114 115.177 95.8237L117.505 95.2221C118.628 94.9318 119.795 94.8502 120.948 94.9813L122.142 95.1172",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2348 102.866L96.4988 102.787C97.8561 102.377 99.2881 102.276 100.689 102.494L101.234 102.578C102.635 102.795 104.067 102.695 105.425 102.285L105.953 102.125C107.31 101.716 108.742 101.615 110.143 101.832L110.688 101.917C112.089 102.134 113.521 102.034 114.879 101.624L115.406 101.464C116.764 101.054 118.196 100.954 119.597 101.171L119.869 101.214",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.055,
    cy: 81.412,
    rx: 3.85,
    ry: 3.85013,
    transform: "rotate(-4 117.055 81.412)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 72.9892L111.143 75.2574C109.664 76.2922 108.901 78.078 109.176 79.8626L109.813 83.997",
    stroke: "white",
    strokeWidth: 3.55391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 75,
    width: 35,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0563 87.3721L90.43 87.7814L89.7275 77.7363L122.816 75.4226L123.518 85.4676L121.851 85.2887C120.738 85.1692 119.613 85.2479 118.527 85.5211L115.274 86.3396C114.189 86.6128 113.063 86.6915 111.95 86.572L108.616 86.2142C107.503 86.0947 106.377 86.1734 105.292 86.4466L102.039 87.2651C100.953 87.5383 99.8281 87.617 98.7151 87.4976L95.3802 87.1397C94.2672 87.0203 93.1418 87.0989 92.0563 87.3721Z",
    fill: "#24284E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4041 95.7985L109.915 79.6803C110.298 79.429 110.814 79.6005 110.97 80.0305C112.962 85.5191 115.751 90.6846 119.247 95.3609L120.197 96.6313L85.4041 95.7985Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5223,
    y: 8.55761,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 92.5223 8.55761)",
    fill: "#60A3FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5223,
    y: 8.55761,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 92.5223 8.55761)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.604 40.0398L108.237 39.659C109.328 39.4048 110.454 39.3457 111.565 39.4846L114.893 39.9006C116.004 40.0394 117.13 39.9804 118.221 39.7262L121.487 38.9646C122.577 38.7104 123.704 38.6513 124.814 38.7902L128.143 39.2062C129.253 39.345 130.38 39.286 131.47 39.0318L134.736 38.2702C135.827 38.016 136.953 37.957 138.064 38.0958L139.728 38.3038",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.961 45.902L110.13 45.6215C111.258 45.3509 112.426 45.2896 113.576 45.4409L115.96 45.7544C117.11 45.9056 118.279 45.8444 119.407 45.5737L121.745 45.0128C122.873 44.7422 124.041 44.6809 125.191 44.8322L127.575 45.1457C128.725 45.2969 129.893 45.2357 131.022 44.965L133.359 44.4041C134.488 44.1334 135.656 44.0722 136.806 44.2235L137.998 44.3802",
    stroke: "white",
    strokeWidth: 2.36925,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.961 45.902L110.13 45.6215C111.258 45.3509 112.426 45.2896 113.576 45.4409L115.96 45.7544C117.11 45.9056 118.279 45.8444 119.407 45.5737L121.745 45.0128C122.873 44.7422 124.041 44.6809 125.191 44.8322L127.575 45.1457C128.725 45.2969 129.893 45.2357 131.022 44.965L133.359 44.4041C134.488 44.1334 135.656 44.0722 136.806 44.2235L137.998 44.3802",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.96 51.6764L112.225 51.6013C113.589 51.2151 115.023 51.14 116.42 51.3814L116.964 51.4754C118.361 51.7168 119.794 51.6417 121.158 51.2555L121.689 51.1053C123.053 50.7192 124.487 50.644 125.884 50.8855L126.427 50.9794C127.825 51.2208 129.258 51.1457 130.622 50.7595L131.153 50.6093C132.517 50.2232 133.951 50.148 135.348 50.3895L135.62 50.4364",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.151,
    cy: 30.5877,
    rx: 3.85,
    ry: 3.85013,
    transform: "rotate(-3 133.151 30.5877)",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 22.1197L127.348 24.331C125.85 25.3398 125.056 27.112 125.3 28.9012L125.865 33.046",
    stroke: "white",
    strokeWidth: 3.55391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 24,
    width: 35,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.052 36.1115L106.419 36.4923L105.892 26.4365L139.015 24.7006L139.542 34.7564L137.878 34.5484C136.768 34.4095 135.641 34.4685 134.551 34.7227L131.284 35.4844C130.194 35.7385 129.068 35.7976 127.957 35.6587L124.629 35.2427C123.518 35.1039 122.391 35.1629 121.301 35.4171L118.035 36.1787C116.945 36.4329 115.818 36.492 114.707 36.3531L111.379 35.9371C110.269 35.7983 109.142 35.8573 108.052 36.1115Z",
    fill: "#24284E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.254 44.4207L126.042 28.7328C126.429 28.4882 126.943 28.6687 127.091 29.1014C128.987 34.6239 131.685 39.8373 135.099 44.5739L136.027 45.8606L101.254 44.4207Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 133.094,
    y: 59.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 133.094 59.0479)",
    fill: "#60A3FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 133.094,
    y: 59.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 133.094 59.0479)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.234 92.0118L144.902 91.8329C146.015 91.7134 147.14 91.7921 148.225 92.0653L151.478 92.8838C152.564 93.157 153.689 93.2357 154.802 93.1162L158.137 92.7584C159.25 92.6389 160.375 92.7176 161.461 92.9908L164.713 93.8093C165.799 94.0825 166.924 94.1612 168.037 94.0417L171.372 93.6839C172.485 93.5644 173.611 93.6431 174.696 93.9163L176.323 94.3256",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.858 98.1172L146.053 97.9813C147.206 97.8502 148.373 97.9318 149.496 98.2221L151.824 98.8237C152.947 99.114 154.114 99.1956 155.266 99.0645L157.655 98.7926C158.808 98.6615 159.975 98.7431 161.098 99.0334L163.426 99.635C164.549 99.9253 165.716 100.007 166.869 99.8758L169.258 99.604C170.41 99.4728 171.577 99.5544 172.701 99.8447L173.865 100.146",
    stroke: "white",
    strokeWidth: 2.36925,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.858 98.1172L146.053 97.9813C147.206 97.8502 148.373 97.9318 149.496 98.2221L151.824 98.8237C152.947 99.114 154.114 99.1956 155.266 99.0645L157.655 98.7926C158.808 98.6615 159.975 98.7431 161.098 99.0334L163.426 99.635C164.549 99.9253 165.716 100.007 166.869 99.8758L169.258 99.604C170.41 99.4728 171.577 99.5544 172.701 99.8447L173.865 100.146",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.131 104.214L147.403 104.172C148.805 103.955 150.237 104.055 151.594 104.465L152.122 104.624C153.479 105.034 154.911 105.134 156.312 104.917L156.857 104.833C158.258 104.616 159.69 104.716 161.048 105.126L161.576 105.285C162.933 105.695 164.365 105.795 165.766 105.578L166.311 105.494C167.712 105.277 169.144 105.377 170.502 105.787L170.765 105.867",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.735,
    cy: 85.8652,
    rx: 3.85,
    ry: 3.85013,
    transform: "rotate(4 170.735 85.8652)",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M169.265 77.1534L165.737 78.9482C164.128 79.7669 163.124 81.4292 163.148 83.2347L163.204 87.4175",
    stroke: "white",
    strokeWidth: 3.55391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 78,
    width: 35,
    height: 13
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.15 88.289L143.482 88.4679L144.185 78.4229L177.273 80.7366L176.571 90.7817L174.944 90.3724C173.859 90.0992 172.733 90.0205 171.62 90.14L168.285 90.4978C167.172 90.6173 166.047 90.5386 164.962 90.2654L161.709 89.4469C160.623 89.1737 159.498 89.095 158.385 89.2145L155.05 89.5723C153.937 89.6918 152.812 89.6131 151.726 89.3399L148.474 88.5214C147.388 88.2482 146.263 88.1695 145.15 88.289Z",
    fill: "#24284E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.389 95.7077L163.905 83.1577C164.318 82.962 164.806 83.2038 164.901 83.6513C166.109 89.3637 168.152 94.867 170.964 99.9844L171.727 101.375L137.389 95.7077Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.722,
    y: 33.7631,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 173.722 33.7631)",
    fill: "#60A3FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 173.722,
    y: 33.7631,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 173.722 33.7631)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.544 62.7166L181.98 62.6633C182.939 62.6278 183.896 62.7623 184.808 63.0608L187.541 63.9552C188.452 64.2537 189.41 64.3882 190.369 64.3527L193.242 64.2461C194.201 64.2105 195.158 64.3451 196.07 64.6435L198.802 65.5379C199.714 65.8364 200.672 65.971 201.63 65.9354L204.503 65.8288C205.462 65.7932 206.42 65.9278 207.332 66.2263L208.698 66.6734",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M181.567 68.0342L182.597 67.9894C183.59 67.9462 184.583 68.0857 185.526 68.4011L187.48 69.0547C188.423 69.3701 189.416 69.5097 190.41 69.4664L192.469 69.3769C193.462 69.3336 194.455 69.4732 195.398 69.7886L197.353 70.4422C198.296 70.7576 199.289 70.8971 200.282 70.8539L202.341 70.7643C203.334 70.7211 204.327 70.8606 205.27 71.176L206.248 71.5028",
    stroke: "white",
    strokeWidth: 2.03079,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.567 68.0342L182.597 67.9894C183.59 67.9462 184.583 68.0857 185.526 68.4011L187.48 69.0547C188.423 69.3701 189.416 69.5097 190.41 69.4664L192.469 69.3769C193.462 69.3336 194.455 69.4732 195.398 69.7886L197.353 70.4422C198.296 70.7576 199.289 70.8971 200.282 70.8539L202.341 70.7643C203.334 70.7211 204.327 70.8606 205.27 71.176L206.248 71.5028",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.146 73.3828L183.381 73.363C184.592 73.2612 185.811 73.4325 186.947 73.8641L187.389 74.032C188.525 74.4637 189.743 74.6349 190.954 74.5331L191.425 74.4935C192.636 74.3918 193.855 74.563 194.991 74.9946L195.433 75.1626C196.569 75.5942 197.787 75.7654 198.998 75.6637L199.469 75.6241C200.68 75.5223 201.899 75.6935 203.035 76.1252L203.256 76.2091",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.425,
    cy: 59.1052,
    rx: 3.3,
    ry: 3.30011,
    transform: "rotate(8 204.425 59.1052)",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.69 51.5689L200.566 52.8926C199.141 53.4964 198.183 54.8577 198.095 56.403L197.893 59.9828",
    stroke: "white",
    strokeWidth: 3.04621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 51,
    width: 31,
    height: 13
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.404 59.6481L180.967 59.7014L182.168 51.1543L210.323 55.1111L209.121 63.6582L207.755 63.211C206.843 62.9125 205.886 62.7779 204.927 62.8135L202.054 62.9201C201.095 62.9557 200.138 62.8211 199.226 62.5226L196.494 61.6283C195.582 61.3298 194.624 61.1952 193.665 61.2308L190.792 61.3374C189.834 61.373 188.876 61.2384 187.964 60.9399L185.232 60.0456C184.32 59.7471 183.363 59.6125 182.404 59.6481Z",
    fill: "#24284E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.324 65.5272L198.747 56.3818C199.113 56.2391 199.515 56.475 199.569 56.8634C200.261 61.82 201.679 66.6478 203.777 71.1916L204.347 72.4259L175.324 65.5272Z",
    fill: "white"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 144.218,
    y: -0.604084,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 144.218 -0.604084)",
    fill: "#60A3FA"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 144.218,
    y: -0.604084,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 144.218 -0.604084)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.533 28.4643L151.971 28.4361C152.93 28.4173 153.885 28.5686 154.791 28.8829L157.508 29.8248C158.414 30.1392 159.369 30.2904 160.329 30.2716L163.203 30.2151C164.162 30.1963 165.117 30.3476 166.024 30.6619L168.74 31.6038C169.646 31.9182 170.602 32.0695 171.561 32.0506L174.435 31.9942C175.394 31.9753 176.349 32.1266 177.256 32.441L178.614 32.9119",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.464 33.7986L152.494 33.7718C153.488 33.7459 154.478 33.9028 155.416 34.2346L157.359 34.9222C158.296 35.254 159.286 35.4109 160.28 35.385L162.34 35.3313C163.335 35.3055 164.325 35.4623 165.262 35.7941L167.205 36.4817C168.142 36.8135 169.133 36.9704 170.127 36.9445L172.187 36.8909C173.181 36.865 174.171 37.0219 175.109 37.3537L176.08 37.6975",
    stroke: "white",
    strokeWidth: 2.03079,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.464 33.7986L152.494 33.7718C153.488 33.7459 154.478 33.9028 155.416 34.2346L157.359 34.9222C158.296 35.254 159.286 35.4109 160.28 35.385L162.34 35.3313C163.335 35.3055 164.325 35.4623 165.262 35.7941L167.205 36.4817C168.142 36.8135 169.133 36.9704 170.127 36.9445L172.187 36.8909C173.181 36.865 174.171 37.0219 175.109 37.3537L176.08 37.6975",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.949 39.1746L153.185 39.1589C154.397 39.0783 155.613 39.2708 156.741 39.7222L157.18 39.8978C158.308 40.3492 159.523 40.5417 160.736 40.461L161.208 40.4297C162.42 40.349 163.636 40.5415 164.764 40.9929L165.203 41.1685C166.331 41.6199 167.546 41.8124 168.759 41.7317L169.231 41.7004C170.443 41.6197 171.659 41.8122 172.787 42.2636L173.006 42.3514",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.474,
    cy: 25.2699,
    rx: 3.3,
    ry: 3.30011,
    transform: "rotate(9 174.474 25.2699)",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.87 17.7219L170.724 18.9909C169.289 19.5698 168.307 20.9142 168.193 22.4577L167.928 26.0334",
    stroke: "white",
    strokeWidth: 3.04621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 16,
    width: 30,
    height: 14
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M152.447 25.4282L151.01 25.4564L152.36 16.9316L180.441 21.3792L179.09 29.904L177.732 29.433C176.826 29.1187 175.871 28.9674 174.911 28.9863L172.037 29.0427C171.078 29.0615 170.123 28.9103 169.216 28.5959L166.5 27.654C165.593 27.3397 164.638 27.1884 163.679 27.2072L160.805 27.2637C159.846 27.2825 158.89 27.1313 157.984 26.8169L155.268 25.875C154.361 25.5606 153.406 25.4094 152.447 25.4282Z",
    fill: "#24284E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.266 31.183L168.845 22.4477C169.213 22.3115 169.611 22.5543 169.659 22.9435C170.264 27.9115 171.597 32.7633 173.615 37.343L174.163 38.5871L145.266 31.183Z",
    fill: "white"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9157,
    y: 27.2736,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 48.9157 27.2736)",
    fill: "#60A3FA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9157,
    y: 27.2736,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 48.9157 27.2736)",
    stroke: "#DAEAFF",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0755 53.9511L63.4631 53.576C64.3894 53.3257 65.3527 53.2414 66.3083 53.3271L69.1717 53.5839C70.1274 53.6696 71.0906 53.5853 72.0169 53.335L74.7922 52.5849C75.7184 52.3345 76.6817 52.2502 77.6374 52.3359L80.5007 52.5928C81.4564 52.6785 82.4197 52.5942 83.3459 52.3438L86.1212 51.5937C87.0475 51.3433 88.0107 51.2591 88.9664 51.3448L90.3981 51.4732",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2687 58.9022L65.2617 58.627C66.22 58.3614 67.2189 58.274 68.2087 58.3691L70.26 58.5663C71.2499 58.6615 72.2488 58.5741 73.2071 58.3085L75.193 57.7581C76.1513 57.4925 77.1502 57.4051 78.14 57.5002L80.1913 57.6975C81.1812 57.7926 82.1801 57.7052 83.1384 57.4396L85.1243 56.8892C86.0826 56.6236 87.0815 56.5362 88.0713 56.6314L89.097 56.73",
    stroke: "white",
    strokeWidth: 2.03079,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2687 58.9022L65.2617 58.627C66.22 58.3614 67.2189 58.274 68.2087 58.3691L70.26 58.5663C71.2499 58.6615 72.2488 58.5741 73.2071 58.3085L75.193 57.7581C76.1513 57.4925 77.1502 57.4051 78.14 57.5002L80.1913 57.6975C81.1812 57.7926 82.1801 57.7052 83.1384 57.4396L85.1243 56.8892C86.0826 56.6236 87.0815 56.5362 88.0713 56.6314L89.097 56.73",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0109 63.7586L67.236 63.6863C68.3931 63.3147 69.6188 63.2075 70.8228 63.3725L71.2912 63.4367C72.4952 63.6017 73.721 63.4945 74.878 63.1229L75.3281 62.9784C76.4852 62.6068 77.711 62.4995 78.915 62.6646L79.3834 62.7287C80.5874 62.8938 81.8131 62.7865 82.9702 62.4149L83.4203 62.2704C84.5774 61.8988 85.8031 61.7916 87.0072 61.9566L87.2413 61.9887",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5331,
    cy: 45.0595,
    rx: 3.3,
    ry: 3.30011,
    transform: "rotate(-5 84.5331 45.0595)",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1211 37.8817L79.3751 39.8742C78.1225 40.7831 77.4952 42.325 77.7577 43.8503L78.3657 47.384",
    stroke: "white",
    strokeWidth: 3.04621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11304_9723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 39,
    width: 30,
    height: 12
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1985 50.5415L61.8108 50.9166L61.0586 42.3184L89.3812 39.8405L90.1334 48.4387L88.7017 48.3103C87.7461 48.2246 86.7828 48.3088 85.8565 48.5592L83.0813 49.3093C82.155 49.5597 81.1917 49.644 80.2361 49.5582L77.3727 49.3014C76.417 49.2157 75.4538 49.3 74.5275 49.5504L71.7522 50.3005C70.826 50.5508 69.8627 50.6351 68.907 50.5494L66.0437 50.2926C65.088 50.2069 64.1247 50.2912 63.1985 50.5415Z",
    fill: "#24284E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11304_9723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6228 57.8632L78.3883 43.6831C78.7121 43.4619 79.1575 43.6012 79.2976 43.9674C81.0867 48.6414 83.554 53.0266 86.6202 56.9819L87.4532 58.0564L57.6228 57.8632Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 85C58 83.8954 58.8954 83 60 83H80.2654C81.2607 83 82.1046 83.7319 82.2453 84.7172L85.7547 109.283C85.8954 110.268 86.7393 111 87.7346 111H188.265C189.261 111 190.105 110.268 190.245 109.283L193.755 84.7172C193.895 83.7319 194.739 83 195.735 83H216C217.105 83 218 83.8954 218 85V111V137C218 138.105 217.105 139 216 139H186H90H60C58.8954 139 58 138.105 58 137V111V85Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M228 22L242 15",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 38.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 45.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 112.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 30 143)",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239 76L260 81.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 24.5L26 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 77L18 82",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveSwimming);
export default __webpack_public_path__ + "static/media/collective-swimming.8ad57b879ed49999c87eab563f966bc6.svg";
export { ForwardRef as ReactComponent };